import { createContext } from "react";
import type { SeVaporOptions } from "@/types";

export const defaultDisplayOption: SeVaporOptions = {
    facilityIds: [0],
    tableLayout: "row",
    buttonLayout: "separate",
    disableRental: false,
    disableReservation: false,
    disableSoftReservation: true,
    allowedCategories: "",
    allowedFeatures: "",
    sort: "",
    vacancyNotice: true,
    vacancyThreshold: 3,
    unavailableUnits: false,
    groupBy: '',
    rentalApp: {
        location: "dialog",
    },
    reservationApp: {
        location: "dialog"
    },
    softReservationApp: {
        location: "dialog"
    },
    additionalUnitSourceInfo: "",
    showAppliedPromotionPrice: false,
    valueBasedPricingSettings: {
        tierA: {
            label: "Standard",
            description: "",
        },
        tierB: {
            label: "Best Value",
            description: "",    
        },
        tierC: { 
            label: "Deluxe",
            description: "",
        },
        tierOrder: ["tierA", "tierB", "tierC"],
    },
    language: {
        grid: {
            strikeThroughRate: "Starting at",
            webRate: "Web Rate",
            promoRate: "Promo Rate"
        },
        action: {    
            reserveButton: "Reserve",
            rentButton: "Rent",
            selectButton: "Select",
            quoteButton: "Get a Quote"
        }
    },
    facilityMap: {},
}

export const DisplayOptionContext = createContext<SeVaporOptions>(defaultDisplayOption);